import { gql } from '@apollo/client/core';

export const CREATE_STUDENT = gql`
  mutation createStudent($createStudentInput: CreateStudentInput!) {
    createStudent(createStudentInput: $createStudentInput) {
      id
      matric_no
      first_name
      surname
      other_name
      dob
      email
      gender
      phone
      home_address
      nationality
      state
      photo
    }
  }
`;

export const EDIT_STUDENT = gql`
  mutation editStudent($input: EditStudentInput!) {
    editStudent(input: $input) {
      id
      matric_no
      first_name
      surname
      other_name
      dob
      email
      gender
      phone
      home_address
      nationality
      state
      city
      photo
    }
  }
`;

export const DELETE_STUDENT = gql`
  mutation DeleteStudent($id: ID!) {
    deleteStudent(id: $id) {
      success
      message
    }
  }
`;

export const PROMOTE_STUDENTS = gql`
  mutation PromoteStudents($input: PromoteStudentsInput!) {
    promoteStudents(input: $input) {
      success
      message
    }
  }
`;

export const MARK_STUDENT_ATTENDANCE = gql`
  mutation MarkStudentAttendance($input: [MarkStudentAttendanceInput!]!) {
    markStudentAttendance(input: $input) {
      success
      message
    }
  }
`;

export const UPDATE_ATTENDANCE_SUMMARY = gql`
  mutation UpdateAttendanceSummary($input: UpdateStudentAttendanceSummaryInput!) {
    updateStudentAttendanceSummary(input: $input) {
      success
      message
    }
  }
`;

export const PREVIEW_STUDENT_IMPORT = gql`
  mutation PreviewStudentImport(
    $students: [StudentImportRecordInput!]!
    $classroom_section_id: Int!
    $programme_id: Int
    $academic_calendar_id: Int
    $campus_id: Int
  ) {
    previewStudentImport(
      students: $students
      classroom_section_id: $classroom_section_id
      programme_id: $programme_id
      academic_calendar_id: $academic_calendar_id
      campus_id: $campus_id
    ) {
      total_rows
      successful
      failed
      errors {
        row
        errors
      }
    }
  }
`;

export const IMPORT_STUDENTS = gql`
  mutation ImportStudents(
    $students: [StudentImportRecordInput!]!
    $classroom_section_id: Int!
    $programme_id: Int
    $academic_calendar_id: Int
    $campus_id: Int
  ) {
    importStudents(
      students: $students
      classroom_section_id: $classroom_section_id
      programme_id: $programme_id
      academic_calendar_id: $academic_calendar_id
      campus_id: $campus_id
    ) {
      total_rows
      successful
      failed
      queued
      student_import_id
      errors {
        row
        errors
      }
    }
  }
`;

export const SAVE_STUDENT_RESULT_FEEDBACK = gql`
  mutation SaveStudentResultFeedback($input: SaveStudentResultFeedbackInput!) {
    saveStudentResultFeedback(input: $input) {
      id
      comment
      rating
      rating_label
      updated_at
    }
  }
`;

export const GENERATE_STUDENT_ID_CARD = gql`
  mutation GenerateStudentIdCard($student_id: ID!) {
    generateStudentIdCard(student_id: $student_id) {
      id
      type
      status
      progress
      file_name
      error_message
      created_at
    }
  }
`;
